<template>
  <div v-if="showTranslationModelPicker" class="gc-translation-model-select">
    <span class="gc-translation-model-select__label">Model</span>
    <v-select
      :value="selectedTranslationModel"
      :items="translationModelOptions"
      item-text="text"
      item-value="value"
      dense
      outlined
      hide-details
      dark
      class="gc-translation-model-select__input"
      @input="onModelChange"
    />
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';

export default {
  name: 'TranslationModelSelect',

  computed: {
    ...mapGetters([
      'showTranslationModelPicker',
      'selectedTranslationModel',
      'translationModels'
    ]),
    translationModelOptions() {
      return this.translationModels.map(entry => ({
        text: entry.modelLabel || entry.model,
        value: entry.model
      }));
    }
  },

  methods: {
    ...mapMutations(['setSelectedTranslationModel']),
    onModelChange(model) {
      this.setSelectedTranslationModel(model);
    }
  }
};
</script>
